<template>

</template>

<script>
import { stepOne, stepTwo, stepThree, stepFour } from "@/api/stake/base.js"
export default {
  data() {
    return {
      params: {},
      account: undefined,
      evmPubkey: undefined,
    }
  },
  methods: {
    handle(obj) {
      this.params = obj
      this.handleOne()
    },
    handleOne() {
      stepOne({
        signData: 'getPublicKey'
      }).then(res => {
        // console.log(res.result.hex)
        this.getPubkeyFunc(res.result.hex)
      })
    },
    async getPubkeyFunc(val) {
      try {
        await window.ethereum.enable();
        const data = val
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        this.account = accounts[0];
        // console.dir(this.account);   //第3步用
        let signature = await window.ethereum.request({
          method: 'personal_sign',
          params: [data, this.account]
        });
        this.handleTwo({
          message: val,
          signature: signature
        })
      } catch (e) {
        console.log("1", e);
      }

    },
    handleTwo(obj) {
      stepTwo(obj).then(res => {
        this.evmPubkey = res.result.pubkey
        this.handleThree(res.result.pubkey)
      })
    },
    handleThree(evmPubkey) {
      let obj = {
        account: this.params.account,
        validatorAddress: this.params.validatorAddress,
        evmPubkey: evmPubkey,
        type: this.params.type,
        amount: this.params.amount
      }
      stepThree(obj).then(res => {
        this.signStakeFunc(JSON.stringify(res.result.msg))
      })
    },
    async signStakeFunc(str) {
      try {
        await window.ethereum.enable();
        const data = str
        let signature = await window.ethereum.request({
          method: 'eth_signTypedData_v4',
          params: [this.account, data]
        });
        // console.dir('signature:' + signature);
        this.handleFour(signature)
      } catch (e) {
        console.log("2", e);
      }
    },
    handleFour(signature) {
      let obj = {
        account: this.params.account,
        validatorAddress: this.params.validatorAddress,
        evmPubkey: this.evmPubkey,
        type: this.params.type,
        amount: this.params.amount,
        signature: signature,
      }
      stepFour(obj).then(res => {
        this.$emit('success')
      })
    }
  },
}
</script>

<style>

</style>